// IANA timezone id -> [lat, lng, [countryIds]].
// Coordinates are the zone's representative city from the tz database's
// zone1970.tab. Country ids are ISO 3166-1 numeric codes for every
// country that uses the zone, matching world-atlas country feature ids,
// so highlights can be clipped to the countries the zone covers.
const TIMEZONE_COORDS = {
  'Africa/Abidjan': [
    5.317,
    -4.033,
    [
      '384',
      '854',
      '288',
      '270',
      '324',
      '352',
      '466',
      '478',
      '654',
      '694',
      '686',
      '768',
    ],
  ],
  'Africa/Algiers': [36.783, 3.05, ['012']],
  'Africa/Bissau': [11.85, -15.583, ['624']],
  'Africa/Cairo': [30.05, 31.25, ['818']],
  'Africa/Casablanca': [33.65, -7.583, ['504']],
  'Africa/Ceuta': [35.883, -5.317, ['724']],
  'Africa/El_Aaiun': [27.15, -13.2, ['732']],
  'Africa/Johannesburg': [-26.25, 28, ['710', '426', '748']],
  'Africa/Juba': [4.85, 31.617, ['728']],
  'Africa/Khartoum': [15.6, 32.533, ['729']],
  'Africa/Lagos': [
    6.45,
    3.4,
    ['566', '024', '204', '180', '140', '178', '120', '266', '226', '562'],
  ],
  'Africa/Maputo': [
    -25.967,
    32.583,
    ['508', '108', '072', '180', '454', '646', '894', '716'],
  ],
  'Africa/Monrovia': [6.3, -10.783, ['430']],
  'Africa/Nairobi': [
    -1.283,
    36.817,
    ['404', '262', '232', '231', '174', '450', '706', '834', '800', '175'],
  ],
  'Africa/Ndjamena': [12.117, 15.05, ['148']],
  'Africa/Sao_Tome': [0.333, 6.733, ['678']],
  'Africa/Tripoli': [32.9, 13.183, ['434']],
  'Africa/Tunis': [36.8, 10.183, ['788']],
  'Africa/Windhoek': [-22.567, 17.1, ['516']],
  'America/Adak': [51.88, -176.658, ['840']],
  'America/Anchorage': [61.218, -149.9, ['840']],
  'America/Araguaina': [-7.2, -48.2, ['076']],
  'America/Argentina/Buenos_Aires': [-34.6, -58.45, ['032']],
  'America/Argentina/Catamarca': [-28.467, -65.783, ['032']],
  'America/Argentina/Cordoba': [-31.4, -64.183, ['032']],
  'America/Argentina/Jujuy': [-24.183, -65.3, ['032']],
  'America/Argentina/La_Rioja': [-29.433, -66.85, ['032']],
  'America/Argentina/Mendoza': [-32.883, -68.817, ['032']],
  'America/Argentina/Rio_Gallegos': [-51.633, -69.217, ['032']],
  'America/Argentina/Salta': [-24.783, -65.417, ['032']],
  'America/Argentina/San_Juan': [-31.533, -68.517, ['032']],
  'America/Argentina/San_Luis': [-33.317, -66.35, ['032']],
  'America/Argentina/Tucuman': [-26.817, -65.217, ['032']],
  'America/Argentina/Ushuaia': [-54.8, -68.3, ['032']],
  'America/Asuncion': [-25.267, -57.667, ['600']],
  'America/Bahia': [-12.983, -38.517, ['076']],
  'America/Bahia_Banderas': [20.8, -105.25, ['484']],
  'America/Barbados': [13.1, -59.617, ['052']],
  'America/Belem': [-1.45, -48.483, ['076']],
  'America/Belize': [17.5, -88.2, ['084']],
  'America/Boa_Vista': [2.817, -60.667, ['076']],
  'America/Bogota': [4.6, -74.083, ['170']],
  'America/Boise': [43.614, -116.203, ['840']],
  'America/Cambridge_Bay': [69.114, -105.053, ['124']],
  'America/Campo_Grande': [-20.45, -54.617, ['076']],
  'America/Cancun': [21.083, -86.767, ['484']],
  'America/Caracas': [10.5, -66.933, ['862']],
  'America/Cayenne': [4.933, -52.333, ['254']],
  'America/Chicago': [41.85, -87.65, ['840']],
  'America/Chihuahua': [28.633, -106.083, ['484']],
  'America/Ciudad_Juarez': [31.733, -106.483, ['484']],
  'America/Costa_Rica': [9.933, -84.083, ['188']],
  'America/Coyhaique': [-45.567, -72.067, ['152']],
  'America/Cuiaba': [-15.583, -56.083, ['076']],
  'America/Danmarkshavn': [76.767, -18.667, ['304']],
  'America/Dawson': [64.067, -139.417, ['124']],
  'America/Dawson_Creek': [55.767, -120.233, ['124']],
  'America/Denver': [39.739, -104.984, ['840']],
  'America/Detroit': [42.331, -83.046, ['840']],
  'America/Edmonton': [53.55, -113.467, ['124']],
  'America/Eirunepe': [-6.667, -69.867, ['076']],
  'America/El_Salvador': [13.7, -89.2, ['222']],
  'America/Fort_Nelson': [58.8, -122.7, ['124']],
  'America/Fortaleza': [-3.717, -38.5, ['076']],
  'America/Glace_Bay': [46.2, -59.95, ['124']],
  'America/Goose_Bay': [53.333, -60.417, ['124']],
  'America/Grand_Turk': [21.467, -71.133, ['796']],
  'America/Guatemala': [14.633, -90.517, ['320']],
  'America/Guayaquil': [-2.167, -79.833, ['218']],
  'America/Guyana': [6.8, -58.167, ['328']],
  'America/Halifax': [44.65, -63.6, ['124']],
  'America/Havana': [23.133, -82.367, ['192']],
  'America/Hermosillo': [29.067, -110.967, ['484']],
  'America/Indiana/Indianapolis': [39.768, -86.158, ['840']],
  'America/Indiana/Knox': [41.296, -86.625, ['840']],
  'America/Indiana/Marengo': [38.376, -86.345, ['840']],
  'America/Indiana/Petersburg': [38.492, -87.279, ['840']],
  'America/Indiana/Tell_City': [37.953, -86.761, ['840']],
  'America/Indiana/Vevay': [38.748, -85.067, ['840']],
  'America/Indiana/Vincennes': [38.677, -87.529, ['840']],
  'America/Indiana/Winamac': [41.051, -86.603, ['840']],
  'America/Inuvik': [68.35, -133.717, ['124']],
  'America/Iqaluit': [63.733, -68.467, ['124']],
  'America/Jamaica': [17.968, -76.793, ['388']],
  'America/Juneau': [58.302, -134.42, ['840']],
  'America/Kentucky/Louisville': [38.254, -85.759, ['840']],
  'America/Kentucky/Monticello': [36.83, -84.849, ['840']],
  'America/La_Paz': [-16.5, -68.15, ['068']],
  'America/Lima': [-12.05, -77.05, ['604']],
  'America/Los_Angeles': [34.052, -118.243, ['840']],
  'America/Maceio': [-9.667, -35.717, ['076']],
  'America/Managua': [12.15, -86.283, ['558']],
  'America/Manaus': [-3.133, -60.017, ['076']],
  'America/Martinique': [14.6, -61.083, ['474']],
  'America/Matamoros': [25.833, -97.5, ['484']],
  'America/Mazatlan': [23.217, -106.417, ['484']],
  'America/Menominee': [45.108, -87.614, ['840']],
  'America/Merida': [20.967, -89.617, ['484']],
  'America/Metlakatla': [55.127, -131.576, ['840']],
  'America/Mexico_City': [19.4, -99.15, ['484']],
  'America/Miquelon': [47.05, -56.333, ['666']],
  'America/Moncton': [46.1, -64.783, ['124']],
  'America/Monterrey': [25.667, -100.317, ['484']],
  'America/Montevideo': [-34.909, -56.213, ['858']],
  'America/New_York': [40.714, -74.006, ['840']],
  'America/Nome': [64.501, -165.406, ['840']],
  'America/Noronha': [-3.85, -32.417, ['076']],
  'America/North_Dakota/Beulah': [47.264, -101.778, ['840']],
  'America/North_Dakota/Center': [47.116, -101.299, ['840']],
  'America/North_Dakota/New_Salem': [46.845, -101.411, ['840']],
  'America/Nuuk': [64.183, -51.733, ['304']],
  'America/Ojinaga': [29.567, -104.417, ['484']],
  'America/Panama': [8.967, -79.533, ['591', '136']],
  'America/Paramaribo': [5.833, -55.167, ['740']],
  'America/Phoenix': [33.448, -112.073, ['840']],
  'America/Port-au-Prince': [18.533, -72.333, ['332']],
  'America/Porto_Velho': [-8.767, -63.9, ['076']],
  'America/Puerto_Rico': [
    18.468,
    -66.106,
    [
      '630',
      '028',
      '660',
      '533',
      '652',
      '535',
      '531',
      '212',
      '308',
      '312',
      '659',
      '662',
      '663',
      '500',
      '534',
      '780',
      '670',
      '092',
      '850',
    ],
  ],
  'America/Punta_Arenas': [-53.15, -70.917, ['152']],
  'America/Rankin_Inlet': [62.817, -92.083, ['124']],
  'America/Recife': [-8.05, -34.9, ['076']],
  'America/Regina': [50.4, -104.65, ['124']],
  'America/Resolute': [74.696, -94.829, ['124']],
  'America/Rio_Branco': [-9.967, -67.8, ['076']],
  'America/Santarem': [-2.433, -54.867, ['076']],
  'America/Santiago': [-33.45, -70.667, ['152']],
  'America/Santo_Domingo': [18.467, -69.9, ['214']],
  'America/Sao_Paulo': [-23.533, -46.617, ['076']],
  'America/Scoresbysund': [70.483, -21.967, ['304']],
  'America/Sitka': [57.176, -135.302, ['840']],
  'America/St_Johns': [47.567, -52.717, ['124']],
  'America/Swift_Current': [50.283, -107.833, ['124']],
  'America/Tegucigalpa': [14.1, -87.217, ['340']],
  'America/Thule': [76.567, -68.783, ['304']],
  'America/Tijuana': [32.533, -117.017, ['484']],
  'America/Toronto': [43.65, -79.383, ['124', '044']],
  'America/Vancouver': [49.267, -123.117, ['124']],
  'America/Whitehorse': [60.717, -135.05, ['124']],
  'America/Winnipeg': [49.883, -97.15, ['124']],
  'America/Yakutat': [59.547, -139.727, ['840']],
  'Antarctica/Casey': [-66.283, 110.517, ['010']],
  'Antarctica/Davis': [-68.583, 77.967, ['010']],
  'Antarctica/Macquarie': [-54.5, 158.95, ['036']],
  'Antarctica/Mawson': [-67.6, 62.883, ['010']],
  'Antarctica/Palmer': [-64.8, -64.1, ['010']],
  'Antarctica/Rothera': [-67.567, -68.133, ['010']],
  'Antarctica/Troll': [-72.011, 2.535, ['010']],
  'Antarctica/Vostok': [-78.4, 106.9, ['010']],
  'Asia/Almaty': [43.25, 76.95, ['398']],
  'Asia/Amman': [31.95, 35.933, ['400']],
  'Asia/Anadyr': [64.75, 177.483, ['643']],
  'Asia/Aqtau': [44.517, 50.267, ['398']],
  'Asia/Aqtobe': [50.283, 57.167, ['398']],
  'Asia/Ashgabat': [37.95, 58.383, ['795']],
  'Asia/Atyrau': [47.117, 51.933, ['398']],
  'Asia/Baghdad': [33.35, 44.417, ['368']],
  'Asia/Baku': [40.383, 49.85, ['031']],
  'Asia/Bangkok': [13.75, 100.517, ['764', '162', '116', '418']],
  'Asia/Barnaul': [53.367, 83.75, ['643']],
  'Asia/Beirut': [33.883, 35.5, ['422']],
  'Asia/Bishkek': [42.9, 74.6, ['417']],
  'Asia/Chita': [52.05, 113.467, ['643']],
  'Asia/Colombo': [6.933, 79.85, ['144']],
  'Asia/Damascus': [33.5, 36.3, ['760']],
  'Asia/Dhaka': [23.717, 90.417, ['050']],
  'Asia/Dili': [-8.55, 125.583, ['626']],
  'Asia/Dubai': [25.3, 55.3, ['784', '512', '638', '690', '260']],
  'Asia/Dushanbe': [38.583, 68.8, ['762']],
  'Asia/Famagusta': [35.117, 33.95, ['196']],
  'Asia/Gaza': [31.5, 34.467, ['275']],
  'Asia/Hebron': [31.533, 35.095, ['275']],
  'Asia/Ho_Chi_Minh': [10.75, 106.667, ['704']],
  'Asia/Hong_Kong': [22.283, 114.15, ['344']],
  'Asia/Hovd': [48.017, 91.65, ['496']],
  'Asia/Irkutsk': [52.267, 104.333, ['643']],
  'Asia/Jakarta': [-6.167, 106.8, ['360']],
  'Asia/Jayapura': [-2.533, 140.7, ['360']],
  'Asia/Jerusalem': [31.781, 35.224, ['376']],
  'Asia/Kabul': [34.517, 69.2, ['004']],
  'Asia/Kamchatka': [53.017, 158.65, ['643']],
  'Asia/Karachi': [24.867, 67.05, ['586']],
  'Asia/Kathmandu': [27.717, 85.317, ['524']],
  'Asia/Khandyga': [62.656, 135.554, ['643']],
  'Asia/Kolkata': [22.533, 88.367, ['356']],
  'Asia/Krasnoyarsk': [56.017, 92.833, ['643']],
  'Asia/Kuching': [1.55, 110.333, ['458', '096']],
  'Asia/Macau': [22.197, 113.542, ['446']],
  'Asia/Magadan': [59.567, 150.8, ['643']],
  'Asia/Makassar': [-5.117, 119.4, ['360']],
  'Asia/Manila': [14.587, 120.968, ['608']],
  'Asia/Nicosia': [35.167, 33.367, ['196']],
  'Asia/Novokuznetsk': [53.75, 87.117, ['643']],
  'Asia/Novosibirsk': [55.033, 82.917, ['643']],
  'Asia/Omsk': [55, 73.4, ['643']],
  'Asia/Oral': [51.217, 51.35, ['398']],
  'Asia/Pontianak': [-0.033, 109.333, ['360']],
  'Asia/Pyongyang': [39.017, 125.75, ['408']],
  'Asia/Qatar': [25.283, 51.533, ['634', '048']],
  'Asia/Qostanay': [53.2, 63.617, ['398']],
  'Asia/Qyzylorda': [44.8, 65.467, ['398']],
  'Asia/Riyadh': [24.633, 46.717, ['682', '414', '887']],
  'Asia/Sakhalin': [46.967, 142.7, ['643']],
  'Asia/Samarkand': [39.667, 66.8, ['860']],
  'Asia/Seoul': [37.55, 126.967, ['410']],
  'Asia/Shanghai': [31.233, 121.467, ['156']],
  'Asia/Singapore': [1.283, 103.85, ['702']],
  'Asia/Srednekolymsk': [67.467, 153.717, ['643']],
  'Asia/Taipei': [25.05, 121.5, ['158']],
  'Asia/Tashkent': [41.333, 69.3, ['860']],
  'Asia/Tbilisi': [41.717, 44.817, ['268']],
  'Asia/Tehran': [35.667, 51.433, ['364']],
  'Asia/Thimphu': [27.467, 89.65, ['064']],
  'Asia/Tokyo': [35.654, 139.745, ['392']],
  'Asia/Tomsk': [56.5, 84.967, ['643']],
  'Asia/Ulaanbaatar': [47.917, 106.883, ['496']],
  'Asia/Urumqi': [43.8, 87.583, ['156']],
  'Asia/Ust-Nera': [64.56, 143.227, ['643']],
  'Asia/Vladivostok': [43.167, 131.933, ['643']],
  'Asia/Yakutsk': [62, 129.667, ['643']],
  'Asia/Yangon': [16.783, 96.167, ['104', '166']],
  'Asia/Yekaterinburg': [56.85, 60.6, ['643']],
  'Asia/Yerevan': [40.183, 44.5, ['051']],
  'Atlantic/Azores': [37.733, -25.667, ['620']],
  'Atlantic/Bermuda': [32.283, -64.767, ['060']],
  'Atlantic/Canary': [28.1, -15.4, ['724']],
  'Atlantic/Cape_Verde': [14.917, -23.517, ['132']],
  'Atlantic/Faroe': [62.017, -6.767, ['234']],
  'Atlantic/Madeira': [32.633, -16.9, ['620']],
  'Atlantic/South_Georgia': [-54.267, -36.533, ['239']],
  'Atlantic/Stanley': [-51.7, -57.85, ['238']],
  'Australia/Adelaide': [-34.917, 138.583, ['036']],
  'Australia/Brisbane': [-27.467, 153.033, ['036']],
  'Australia/Broken_Hill': [-31.95, 141.45, ['036']],
  'Australia/Darwin': [-12.467, 130.833, ['036']],
  'Australia/Eucla': [-31.717, 128.867, ['036']],
  'Australia/Hobart': [-42.883, 147.317, ['036']],
  'Australia/Lindeman': [-20.267, 149, ['036']],
  'Australia/Lord_Howe': [-31.55, 159.083, ['036']],
  'Australia/Melbourne': [-37.817, 144.967, ['036']],
  'Australia/Perth': [-31.95, 115.85, ['036']],
  'Australia/Sydney': [-33.867, 151.217, ['036']],
  'Europe/Andorra': [42.5, 1.517, ['020']],
  'Europe/Astrakhan': [46.35, 48.05, ['643']],
  'Europe/Athens': [37.967, 23.717, ['300']],
  'Europe/Belgrade': [44.833, 20.5, ['688', '070', '191', '499', '807', '705']],
  'Europe/Berlin': [52.5, 13.367, ['276', '208', '578', '752', '744']],
  'Europe/Brussels': [50.833, 4.333, ['056', '442', '528']],
  'Europe/Bucharest': [44.433, 26.1, ['642']],
  'Europe/Budapest': [47.5, 19.083, ['348']],
  'Europe/Chisinau': [47, 28.833, ['498']],
  'Europe/Dublin': [53.333, -6.25, ['372']],
  'Europe/Gibraltar': [36.133, -5.35, ['292']],
  'Europe/Helsinki': [60.167, 24.967, ['246', '248']],
  'Europe/Istanbul': [41.017, 28.967, ['792']],
  'Europe/Kaliningrad': [54.717, 20.5, ['643']],
  'Europe/Kirov': [58.6, 49.65, ['643']],
  'Europe/Kyiv': [50.433, 30.517, ['804']],
  'Europe/Lisbon': [38.717, -9.133, ['620']],
  'Europe/London': [51.508, -0.125, ['826', '831', '833', '832']],
  'Europe/Madrid': [40.4, -3.683, ['724']],
  'Europe/Malta': [35.9, 14.517, ['470']],
  'Europe/Minsk': [53.9, 27.567, ['112']],
  'Europe/Moscow': [55.756, 37.618, ['643']],
  'Europe/Paris': [48.867, 2.333, ['250', '492']],
  'Europe/Prague': [50.083, 14.433, ['203', '703']],
  'Europe/Riga': [56.95, 24.1, ['428']],
  'Europe/Rome': [41.9, 12.483, ['380', '674', '336']],
  'Europe/Samara': [53.2, 50.15, ['643']],
  'Europe/Saratov': [51.567, 46.033, ['643']],
  'Europe/Simferopol': [44.95, 34.1, ['643']],
  'Europe/Sofia': [42.683, 23.317, ['100']],
  'Europe/Tallinn': [59.417, 24.75, ['233']],
  'Europe/Tirane': [41.333, 19.833, ['008']],
  'Europe/Ulyanovsk': [54.333, 48.4, ['643']],
  'Europe/Vienna': [48.217, 16.333, ['040']],
  'Europe/Vilnius': [54.683, 25.317, ['440']],
  'Europe/Volgograd': [48.733, 44.417, ['643']],
  'Europe/Warsaw': [52.25, 21, ['616']],
  'Europe/Zurich': [47.383, 8.533, ['756', '438']],
  'Indian/Chagos': [-7.333, 72.417, ['086']],
  'Indian/Maldives': [4.167, 73.5, ['462', '260']],
  'Indian/Mauritius': [-20.167, 57.5, ['480']],
  'Pacific/Apia': [-13.833, -171.733, ['882']],
  'Pacific/Auckland': [-36.867, 174.767, ['554']],
  'Pacific/Bougainville': [-6.217, 155.567, ['598']],
  'Pacific/Chatham': [-43.95, -176.55, ['554']],
  'Pacific/Easter': [-27.15, -109.433, ['152']],
  'Pacific/Efate': [-17.667, 168.417, ['548']],
  'Pacific/Fakaofo': [-9.367, -171.233, ['772']],
  'Pacific/Fiji': [-18.133, 178.417, ['242']],
  'Pacific/Galapagos': [-0.9, -89.6, ['218']],
  'Pacific/Gambier': [-23.133, -134.95, ['258']],
  'Pacific/Guadalcanal': [-9.533, 160.2, ['090']],
  'Pacific/Guam': [13.467, 144.75, ['316', '580']],
  'Pacific/Honolulu': [21.307, -157.858, ['840']],
  'Pacific/Kanton': [-2.783, -171.717, ['296']],
  'Pacific/Kiritimati': [1.867, -157.333, ['296']],
  'Pacific/Kosrae': [5.317, 162.983, ['583']],
  'Pacific/Kwajalein': [9.083, 167.333, ['584']],
  'Pacific/Marquesas': [-9, -139.5, ['258']],
  'Pacific/Nauru': [-0.517, 166.917, ['520']],
  'Pacific/Niue': [-19.017, -169.917, ['570']],
  'Pacific/Norfolk': [-29.05, 167.967, ['574']],
  'Pacific/Noumea': [-22.267, 166.45, ['540']],
  'Pacific/Pago_Pago': [-14.267, -170.7, ['016', '581']],
  'Pacific/Palau': [7.333, 134.483, ['585']],
  'Pacific/Pitcairn': [-25.067, -130.083, ['612']],
  'Pacific/Port_Moresby': [-9.5, 147.167, ['598']],
  'Pacific/Rarotonga': [-21.233, -159.767, ['184']],
  'Pacific/Tahiti': [-17.533, -149.567, ['258']],
  'Pacific/Tarawa': [1.417, 173, ['296', '798', '581', '876']],
  'Pacific/Tongatapu': [-21.133, -175.2, ['776']],
}

// Legacy alias -> canonical zone id, from the tz database's backward
// file. Older clients report ids like US/Pacific or Asia/Calcutta;
// the map folds them into the canonical zone before rendering.
export const TIMEZONE_ALIASES = {
  'Africa/Accra': 'Africa/Abidjan',
  'Africa/Addis_Ababa': 'Africa/Nairobi',
  'Africa/Asmara': 'Africa/Nairobi',
  'Africa/Asmera': 'Africa/Nairobi',
  'Africa/Bamako': 'Africa/Abidjan',
  'Africa/Bangui': 'Africa/Lagos',
  'Africa/Banjul': 'Africa/Abidjan',
  'Africa/Blantyre': 'Africa/Maputo',
  'Africa/Brazzaville': 'Africa/Lagos',
  'Africa/Bujumbura': 'Africa/Maputo',
  'Africa/Conakry': 'Africa/Abidjan',
  'Africa/Dakar': 'Africa/Abidjan',
  'Africa/Dar_es_Salaam': 'Africa/Nairobi',
  'Africa/Djibouti': 'Africa/Nairobi',
  'Africa/Douala': 'Africa/Lagos',
  'Africa/Freetown': 'Africa/Abidjan',
  'Africa/Gaborone': 'Africa/Maputo',
  'Africa/Harare': 'Africa/Maputo',
  'Africa/Kampala': 'Africa/Nairobi',
  'Africa/Kigali': 'Africa/Maputo',
  'Africa/Kinshasa': 'Africa/Lagos',
  'Africa/Libreville': 'Africa/Lagos',
  'Africa/Lome': 'Africa/Abidjan',
  'Africa/Luanda': 'Africa/Lagos',
  'Africa/Lubumbashi': 'Africa/Maputo',
  'Africa/Lusaka': 'Africa/Maputo',
  'Africa/Malabo': 'Africa/Lagos',
  'Africa/Maseru': 'Africa/Johannesburg',
  'Africa/Mbabane': 'Africa/Johannesburg',
  'Africa/Mogadishu': 'Africa/Nairobi',
  'Africa/Niamey': 'Africa/Lagos',
  'Africa/Nouakchott': 'Africa/Abidjan',
  'Africa/Ouagadougou': 'Africa/Abidjan',
  'Africa/Porto-Novo': 'Africa/Lagos',
  'Africa/Timbuktu': 'Africa/Abidjan',
  'America/Anguilla': 'America/Puerto_Rico',
  'America/Antigua': 'America/Puerto_Rico',
  'America/Argentina/ComodRivadavia': 'America/Argentina/Catamarca',
  'America/Aruba': 'America/Puerto_Rico',
  'America/Atikokan': 'America/Panama',
  'America/Atka': 'America/Adak',
  'America/Blanc-Sablon': 'America/Puerto_Rico',
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Catamarca': 'America/Argentina/Catamarca',
  'America/Cayman': 'America/Panama',
  'America/Coral_Harbour': 'America/Panama',
  'America/Cordoba': 'America/Argentina/Cordoba',
  'America/Creston': 'America/Phoenix',
  'America/Curacao': 'America/Puerto_Rico',
  'America/Dominica': 'America/Puerto_Rico',
  'America/Ensenada': 'America/Tijuana',
  'America/Fort_Wayne': 'America/Indiana/Indianapolis',
  'America/Godthab': 'America/Nuuk',
  'America/Grenada': 'America/Puerto_Rico',
  'America/Guadeloupe': 'America/Puerto_Rico',
  'America/Indianapolis': 'America/Indiana/Indianapolis',
  'America/Jujuy': 'America/Argentina/Jujuy',
  'America/Knox_IN': 'America/Indiana/Knox',
  'America/Kralendijk': 'America/Puerto_Rico',
  'America/Louisville': 'America/Kentucky/Louisville',
  'America/Lower_Princes': 'America/Puerto_Rico',
  'America/Marigot': 'America/Puerto_Rico',
  'America/Mendoza': 'America/Argentina/Mendoza',
  'America/Montreal': 'America/Toronto',
  'America/Montserrat': 'America/Puerto_Rico',
  'America/Nassau': 'America/Toronto',
  'America/Nipigon': 'America/Toronto',
  'America/Pangnirtung': 'America/Iqaluit',
  'America/Port_of_Spain': 'America/Puerto_Rico',
  'America/Porto_Acre': 'America/Rio_Branco',
  'America/Rainy_River': 'America/Winnipeg',
  'America/Rosario': 'America/Argentina/Cordoba',
  'America/Santa_Isabel': 'America/Tijuana',
  'America/Shiprock': 'America/Denver',
  'America/St_Barthelemy': 'America/Puerto_Rico',
  'America/St_Kitts': 'America/Puerto_Rico',
  'America/St_Lucia': 'America/Puerto_Rico',
  'America/St_Thomas': 'America/Puerto_Rico',
  'America/St_Vincent': 'America/Puerto_Rico',
  'America/Thunder_Bay': 'America/Toronto',
  'America/Tortola': 'America/Puerto_Rico',
  'America/Virgin': 'America/Puerto_Rico',
  'America/Yellowknife': 'America/Edmonton',
  'Antarctica/DumontDUrville': 'Pacific/Port_Moresby',
  'Antarctica/McMurdo': 'Pacific/Auckland',
  'Antarctica/South_Pole': 'Pacific/Auckland',
  'Antarctica/Syowa': 'Asia/Riyadh',
  'Arctic/Longyearbyen': 'Europe/Berlin',
  'Asia/Aden': 'Asia/Riyadh',
  'Asia/Ashkhabad': 'Asia/Ashgabat',
  'Asia/Bahrain': 'Asia/Qatar',
  'Asia/Brunei': 'Asia/Kuching',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Choibalsan': 'Asia/Ulaanbaatar',
  'Asia/Chongqing': 'Asia/Shanghai',
  'Asia/Chungking': 'Asia/Shanghai',
  'Asia/Dacca': 'Asia/Dhaka',
  'Asia/Harbin': 'Asia/Shanghai',
  'Asia/Istanbul': 'Europe/Istanbul',
  'Asia/Kashgar': 'Asia/Urumqi',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Kuala_Lumpur': 'Asia/Singapore',
  'Asia/Kuwait': 'Asia/Riyadh',
  'Asia/Macao': 'Asia/Macau',
  'Asia/Muscat': 'Asia/Dubai',
  'Asia/Phnom_Penh': 'Asia/Bangkok',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Tel_Aviv': 'Asia/Jerusalem',
  'Asia/Thimbu': 'Asia/Thimphu',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Asia/Ulan_Bator': 'Asia/Ulaanbaatar',
  'Asia/Vientiane': 'Asia/Bangkok',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'Atlantic/Jan_Mayen': 'Europe/Berlin',
  'Atlantic/Reykjavik': 'Africa/Abidjan',
  'Atlantic/St_Helena': 'Africa/Abidjan',
  'Australia/ACT': 'Australia/Sydney',
  'Australia/Canberra': 'Australia/Sydney',
  'Australia/Currie': 'Australia/Hobart',
  'Australia/LHI': 'Australia/Lord_Howe',
  'Australia/NSW': 'Australia/Sydney',
  'Australia/North': 'Australia/Darwin',
  'Australia/Queensland': 'Australia/Brisbane',
  'Australia/South': 'Australia/Adelaide',
  'Australia/Tasmania': 'Australia/Hobart',
  'Australia/Victoria': 'Australia/Melbourne',
  'Australia/West': 'Australia/Perth',
  'Australia/Yancowinna': 'Australia/Broken_Hill',
  'Brazil/Acre': 'America/Rio_Branco',
  'Brazil/DeNoronha': 'America/Noronha',
  'Brazil/East': 'America/Sao_Paulo',
  'Brazil/West': 'America/Manaus',
  CET: 'Europe/Brussels',
  'Canada/Atlantic': 'America/Halifax',
  'Canada/Central': 'America/Winnipeg',
  'Canada/Eastern': 'America/Toronto',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Newfoundland': 'America/St_Johns',
  'Canada/Pacific': 'America/Vancouver',
  'Canada/Saskatchewan': 'America/Regina',
  'Canada/Yukon': 'America/Whitehorse',
  'Chile/Continental': 'America/Santiago',
  'Chile/EasterIsland': 'Pacific/Easter',
  Cuba: 'America/Havana',
  EET: 'Europe/Athens',
  EST: 'America/Panama',
  Egypt: 'Africa/Cairo',
  Eire: 'Europe/Dublin',
  'Europe/Amsterdam': 'Europe/Brussels',
  'Europe/Belfast': 'Europe/London',
  'Europe/Bratislava': 'Europe/Prague',
  'Europe/Busingen': 'Europe/Zurich',
  'Europe/Copenhagen': 'Europe/Berlin',
  'Europe/Guernsey': 'Europe/London',
  'Europe/Isle_of_Man': 'Europe/London',
  'Europe/Jersey': 'Europe/London',
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Ljubljana': 'Europe/Belgrade',
  'Europe/Luxembourg': 'Europe/Brussels',
  'Europe/Mariehamn': 'Europe/Helsinki',
  'Europe/Monaco': 'Europe/Paris',
  'Europe/Nicosia': 'Asia/Nicosia',
  'Europe/Oslo': 'Europe/Berlin',
  'Europe/Podgorica': 'Europe/Belgrade',
  'Europe/San_Marino': 'Europe/Rome',
  'Europe/Sarajevo': 'Europe/Belgrade',
  'Europe/Skopje': 'Europe/Belgrade',
  'Europe/Stockholm': 'Europe/Berlin',
  'Europe/Tiraspol': 'Europe/Chisinau',
  'Europe/Uzhgorod': 'Europe/Kyiv',
  'Europe/Vaduz': 'Europe/Zurich',
  'Europe/Vatican': 'Europe/Rome',
  'Europe/Zagreb': 'Europe/Belgrade',
  'Europe/Zaporozhye': 'Europe/Kyiv',
  GB: 'Europe/London',
  'GB-Eire': 'Europe/London',
  HST: 'Pacific/Honolulu',
  Hongkong: 'Asia/Hong_Kong',
  Iceland: 'Africa/Abidjan',
  'Indian/Antananarivo': 'Africa/Nairobi',
  'Indian/Christmas': 'Asia/Bangkok',
  'Indian/Cocos': 'Asia/Yangon',
  'Indian/Comoro': 'Africa/Nairobi',
  'Indian/Kerguelen': 'Indian/Maldives',
  'Indian/Mahe': 'Asia/Dubai',
  'Indian/Mayotte': 'Africa/Nairobi',
  'Indian/Reunion': 'Asia/Dubai',
  Iran: 'Asia/Tehran',
  Israel: 'Asia/Jerusalem',
  Jamaica: 'America/Jamaica',
  Japan: 'Asia/Tokyo',
  Kwajalein: 'Pacific/Kwajalein',
  Libya: 'Africa/Tripoli',
  MET: 'Europe/Brussels',
  MST: 'America/Phoenix',
  'Mexico/BajaNorte': 'America/Tijuana',
  'Mexico/BajaSur': 'America/Mazatlan',
  'Mexico/General': 'America/Mexico_City',
  NZ: 'Pacific/Auckland',
  'NZ-CHAT': 'Pacific/Chatham',
  Navajo: 'America/Denver',
  PRC: 'Asia/Shanghai',
  'Pacific/Chuuk': 'Pacific/Port_Moresby',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'Pacific/Funafuti': 'Pacific/Tarawa',
  'Pacific/Johnston': 'Pacific/Honolulu',
  'Pacific/Majuro': 'Pacific/Tarawa',
  'Pacific/Midway': 'Pacific/Pago_Pago',
  'Pacific/Pohnpei': 'Pacific/Guadalcanal',
  'Pacific/Ponape': 'Pacific/Guadalcanal',
  'Pacific/Saipan': 'Pacific/Guam',
  'Pacific/Samoa': 'Pacific/Pago_Pago',
  'Pacific/Truk': 'Pacific/Port_Moresby',
  'Pacific/Wake': 'Pacific/Tarawa',
  'Pacific/Wallis': 'Pacific/Tarawa',
  'Pacific/Yap': 'Pacific/Port_Moresby',
  Poland: 'Europe/Warsaw',
  Portugal: 'Europe/Lisbon',
  ROC: 'Asia/Taipei',
  ROK: 'Asia/Seoul',
  Singapore: 'Asia/Singapore',
  Turkey: 'Europe/Istanbul',
  'US/Alaska': 'America/Anchorage',
  'US/Aleutian': 'America/Adak',
  'US/Arizona': 'America/Phoenix',
  'US/Central': 'America/Chicago',
  'US/East-Indiana': 'America/Indiana/Indianapolis',
  'US/Eastern': 'America/New_York',
  'US/Hawaii': 'Pacific/Honolulu',
  'US/Indiana-Starke': 'America/Indiana/Knox',
  'US/Michigan': 'America/Detroit',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Samoa': 'Pacific/Pago_Pago',
  'W-SU': 'Europe/Moscow',
  WET: 'Europe/Lisbon',
}

export default TIMEZONE_COORDS
